/*
	Takes triggers and targets - both which require data-type attributes.
	When a $trigger is clicked it adds/removes 'is-active' class to each $target if
	it's type matches the clicked $trigger type.
 */

export default function multiSwitcher(triggers, targets) {
	triggers.forEach(trigger => {
		trigger.addEventListener("click", e => {
			activate(trigger, triggers, targets);
			// e.preventDefault();
		});
	});

	const hash = window.location.hash;
	if (hash) {
		let id = hash.replace("#", "");
		let trigger = document.querySelector(
			`[data-switcher-trigger][data-type='${id}']`
		);
		activate(trigger, triggers, targets);
	}
}

function activate(trigger, triggers, targets) {
	var newType = trigger.dataset.type;
	targets.forEach(target => {
		if (target.dataset.type && target.dataset.type === newType) {
			target.classList.add("is-active");
		} else {
			target.classList.remove("is-active");
		}
	});

	triggers.forEach(trigger => {
		trigger.classList.remove("is-active");
	});
	trigger.classList.add("is-active");
}
